import SunAndMoon from './SunAndMoon';

export default SunAndMoon;
